



































import AbpBase from '../../../lib/abpbase'
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import {
    QuryConsumableWarning
} from '../../../api/consumablesStock'
//单据打印组件
import print from '../../../components/print/stockBills.vue'

@Component({
    components:{print}
})
export default class IndateWarning extends AbpBase {
	//名称检索
	@Watch('conName')
	WatchconName(val: string, oldVal: string) { 
		this.table.currentPage = 1
		this.getData()
    }
    @Watch('date')
	Watchdate(val: any, oldVal: any) { 
		this.table.currentPage = 1
		this.getData()
	}
	
	printShow:Boolean = false;
    printData = {
        list:[],
        title:[
            '耗材名称',
            '生产厂家',
            '规格型号',
            '批次号',
            '入库时间',
            '入库数量',
            '基本单位',
            '零价',
            '有效期',
        ]
	}


    date = []
	conName = ''//名称检索
	list = []//table数据源

	table = {
		loading:false,
		totalCount : 0,
		pageSize : 10,
		currentPage:1
	}
	
	created(){
		this.getData()
    }
    //数据导出
    exportData(){
        (this.$refs.table as any).exportCsv({
            filename: 'The original data',
            original:false
        })
    }
    print(){
		this.printData.list = []
		this.list.forEach((item,index)=>{
			this.printData.list.push([
				item.consumableName,
				item.manufacturer,
				item.specModel,
				item.batchNo,
				Util.formatTime(item.stockInDate),
				item.quantity,
				item.basicUnitName,
				item.price,
				Util.formatTime(item.validityPeriod)
			])
		})
		this.printShow = true
	}
	//打印完成回调
    printBack(){
        this.printShow = false;
    }
	async getData(){
		this.table.loading = true
		let payload = {
            queryString:this.conName,
            startTime:''||this.date[0],
            endTime:''||this.date[1],
			pageSize:this.table.pageSize,
			page:this.table.currentPage
		}
		let response = await QuryConsumableWarning(payload)
		this.list = response.data.items
	
		this.table.totalCount = response.data.totalCount
		this.table.loading = false
	}
	pageChange(page: number) {
		this.table.currentPage = page
		this.getData()
	}
	columns = [{
        type: 'add.vue',
		title: this.L('OwnCoding'),
	},{
		title: "耗材名称",
		key: 'consumableName'
	},{
		title: "生产厂家",
		key: 'manufacturer'
	},{
		title: "规格型号",
		key: 'specModel'
	},{
		title: "批次号",
		key:'batchNo'
    },{
		title: "入库时间",
		key:'stockInDate',
		render: (h: any, params: any) => {
            return h('span',Util.formatTime(params.row.stockInDate))
        }
    },{
		title: "入库数量",
		key:'quantity'
    },{
		title: "基本单位",
		key: 'basicUnitName'
	},{
		title: "零价",
		key:'price'
    },{
		title: "有效期",
        key:'validityPeriod',
        render: (h: any, params: any) => {
            return h('span',Util.formatTime(params.row.validityPeriod))
        }
    }
    ]
	
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/consumablesStock/indateWarning/index.vue